import { Input as HeroInput, InputProps } from '@conexasaude/hero'
import { useField } from '@unform/core'
import { FunctionComponent, useEffect, useRef, ChangeEvent } from 'react'
import InputMask from 'react-input-mask'

interface IInput extends InputProps {
  mask?: string | (string | RegExp)[]
  maskPlaceholder?: string
  handleChange?(event: ChangeEvent<HTMLInputElement>): void
}
const Input: FunctionComponent<IInput> = ({
  inputProps,
  handleChange,
  mask,
  maskPlaceholder,
  disabled,
  ...rest
}) => {
  const { fieldName, registerField, defaultValue, error } = useField(
    inputProps.name,
  )
  const inputRef = useRef<HTMLInputElement>(null)
  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef,
      getValue: ref => {
        return ref.current?.value
      },
      setValue: (ref, value) => {
        ref.current.value = value
      },
      clearValue: ref => {
        ref.current.value = ''
      },
    })
  }, [registerField, fieldName])

  return (
    <InputMask
      onChange={handleChange}
      mask={mask}
      alwaysShowMask={!!maskPlaceholder}
      maskPlaceholder={maskPlaceholder}
      disabled={disabled}
    >
      <HeroInput
        placeholder="Type your username"
        inputProps={{
          defaultValue: defaultValue,
          ...inputProps,
        }}
        inputRef={inputRef}
        error={!!error}
        errorMessage={error}
        {...rest}
      />
    </InputMask>
  )
}

export default Input
